import { render, staticRenderFns } from "./processList.vue?vue&type=template&id=52e83fcd&scoped=true"
import script from "./processList.vue?vue&type=script&lang=js"
export * from "./processList.vue?vue&type=script&lang=js"
import style0 from "./processList.vue?vue&type=style&index=0&id=52e83fcd&prod&scoped=true&lang=css"
import style1 from "./processList.vue?vue&type=style&index=1&id=52e83fcd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e83fcd",
  null
  
)

export default component.exports